import { Changelog1 } from '@/components/Changelog/changelog'
import type { ChangelogEntry } from '@/components/Changelog/changelog'

// Histórico de atualizações do sistema Hermes
const changelogEntries: ChangelogEntry[] = [
  {
    version: 'Versão 2.0.0',
    date: '12 de Janeiro de 2026',
    title: 'Página de Changelog Implementada',
    description:
      'Adicionamos uma página dedicada para exibir o histórico de atualizações do sistema Hermes, permitindo que os usuários acompanhem todas as melhorias e novos recursos.',
    items: [
      'Nova página de Changelog acessível via sidebar',
      'Histórico completo de atualizações do sistema',
      'Interface intuitiva e organizada por versões',
      'Atalho rápido no footer da sidebar',
    ],
  },
  {
    version: 'Versão 1.5.0',
    date: '15 de Dezembro de 2025',
    title: 'Melhorias na Gestão de Demandas',
    description:
      'Implementamos diversas melhorias no sistema de gestão de demandas, tornando o fluxo de trabalho mais eficiente e intuitivo.',
    items: [
      'Novo dashboard com métricas em tempo real',
      'Sistema de notificações aprimorado',
      'Filtros avançados para busca de demandas',
      'Exportação de relatórios em PDF e Excel',
      'Melhorias na interface de calendário',
    ],
  },
  {
    version: 'Versão 1.4.0',
    date: '01 de Novembro de 2025',
    title: 'Sistema de Atalhos de Teclado',
    description:
      'Implementamos um sistema completo de atalhos de teclado para melhorar a produtividade dos usuários, permitindo navegação rápida e acesso facilitado às funcionalidades principais.',
    items: [
      'Mais de 20 atalhos de teclado implementados',
      'Modal de ajuda com todos os atalhos disponíveis (Ctrl+H)',
      'Navegação rápida entre páginas',
      'Atalhos para criação e edição de demandas',
      'Configuração personalizável de atalhos',
    ],
  },
  {
    version: 'Versão 1.3.0',
    date: '15 de Outubro de 2025',
    title: 'Gestão de Colaboradores',
    description:
      'Nova funcionalidade de gestão de colaboradores, permitindo que gestores e administradores gerenciem melhor suas equipes.',
    items: [
      'Visualização completa de colaboradores',
      'Gerenciamento de setores e funções',
      'Controle de permissões por usuário',
      'Histórico de atividades dos colaboradores',
    ],
  },
  {
    version: 'Versão 1.2.0',
    date: '01 de Setembro de 2025',
    title: 'Sistema de Calendário',
    description:
      'Implementação do calendário integrado para melhor visualização e organização das demandas por data.',
    items: [
      'Visualização de demandas em calendário',
      'Filtros por status e responsável',
      'Criação rápida de demandas a partir do calendário',
      'Sincronização em tempo real',
    ],
  },
  {
    version: 'Versão 1.1.0',
    date: '15 de Agosto de 2025',
    title: 'Melhorias de Performance',
    description:
      'Otimizações gerais de performance e correções de bugs identificados pelos usuários.',
    items: [
      'Melhorias significativas no tempo de carregamento',
      'Otimização de consultas ao banco de dados',
      'Correção de bugs na criação de demandas',
      'Melhorias na responsividade mobile',
    ],
  },
  {
    version: 'Versão 1.0.0',
    date: '01 de Julho de 2025',
    title: 'Lançamento Oficial do Sistema Hermes',
    description:
      'Lançamento oficial do sistema de gestão de demandas Hermes, uma plataforma completa para gerenciamento eficiente de tarefas e projetos.',
    items: [
      'Sistema completo de gestão de demandas',
      'Dashboard intuitivo e informativo',
      'Sistema de autenticação e autorização',
      'Gestão de processos e setores',
      'Interface moderna e responsiva',
      'Modo claro e escuro',
    ],
  },
]

export const ChangelogPage = () => {
  return (
    <div className='min-h-screen bg-background'>
      <Changelog1
        title='Histórico de Atualizações'
        description='Acompanhe todas as melhorias e novos recursos do sistema Hermes.'
        entries={changelogEntries}
      />
    </div>
  )
}

export default ChangelogPage
